import { ItemsPerPage } from '../items-per-page';

export class ItemsPerPageBuilder {

  static fromJson(json): ItemsPerPage {
    return (json) ? new ItemsPerPage(
      json.itemsPerPage,
    ) : null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/items-per-page-builder.ts